<div class="notif" [class.collapsed]="isCollapsed">
  <button
    type="button"
    class="notif__trigger"
    (click)="toggle($event)"
    [attr.aria-label]="'notifications.title' | translate"
    [attr.aria-expanded]="open()"
    [title]="'notifications.title' | translate"
    id="notification-bell-trigger"
  >
    <span nz-icon nzType="bell" nzTheme="outline"></span>
    @if (unreadCount() > 0) {
      <span class="notif__badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  </button>

  @if (open()) {
    <div class="notif__panel" (click)="$event.stopPropagation()">
      <div class="notif__header">
        <span class="notif__title">{{ 'notifications.title' | translate }}</span>
        @if (unreadCount() > 0) {
          <button
            type="button"
            class="notif__mark-all"
            (click)="markAllRead($event)"
            id="notification-bell-mark-all-read-button"
          >
            {{ 'notifications.markAllRead' | translate }}
          </button>
        }
      </div>

      <div class="notif__list">
        @if (loading() && recent().length === 0) {
          <div class="notif__empty">
            <span nz-icon nzType="loading"></span>
          </div>
        } @else if (recent().length === 0) {
          <div class="notif__empty">{{ 'notifications.empty' | translate }}</div>
        } @else {
          @for (n of recent(); track n._id) {
            <button
              type="button"
              class="notif__item"
              [class.unread]="!n.readAt"
              [ngClass]="'priority-' + n.priority"
              (click)="openNotification(n)"
              [attr.id]="'notification-bell-item-' + n._id"
            >
              <span class="notif__dot" [class.hidden]="!!n.readAt"></span>
              <span class="notif__body">
                <span class="notif__text">{{ n.titleKey | translate: params(n) }}</span>
                <span class="notif__meta">
                  {{ 'notifications.groups.' + n.group | translate }} · {{ timeAgo(n) }}
                </span>
              </span>
            </button>
          }
        }
      </div>

      <button
        type="button"
        class="notif__footer"
        (click)="viewAll()"
        id="notification-bell-view-all-button"
      >
        {{ 'notifications.viewAll' | translate }}
        <span nz-icon nzType="arrow-right"></span>
      </button>
    </div>
  }
</div>
